import { useCallback, useState } from 'react';
import './cargarReclamo.css';
import Swal from 'sweetalert2';
import CardDocsCargarReclamo from '../components/CargarReclamo/CardDocsCargarReclamo';
import axios from 'axios';
export default function CargarReclamo() {
  // datos solicitud
  const [solicitud, setSolicitud] = useState({
    tipoReclamante: null,
    patenteRec: null,
    patenteAseg: null,
    fechaStroRec: null,
    nombreAsegAGS: null,
    obsReclamante: null,
    nombreReclamante: null,
  });
  // datos personales
  const [datosPersonales, setDatosPersonales] = useState({
    nombreReclamante: null,
    dniReclamante: null,
    telefonoReclamante: null,
    nombreConductor: null,
    dniConductor: null,
    telefonoConductor: null,
  });
  const [mismosDatos, setMismosDatos] = useState(1);
  const [errores, setErrores] = useState({});
  const validarCampo = (campo, valor) => {
    let mensaje = '';
    if (campo.includes('dni')) {
      if (!/^\d{8}$/.test(valor)) {
        mensaje = 'El DNI debe tener 8 números.';
      }
    }
    if (campo.includes('telefono')) {
      if (!/^(\+?54|0)?\d{8,13}$/.test(valor)) {
        mensaje = 'Ingrese un teléfono válido.';
      }
    }
    setErrores(prev => ({ ...prev, [campo]: mensaje }));
  };
  // detalle
  const [detallesSiniestro, setDetallesSiniestro] = useState({
    relatoSiniestro: null,
  });
  // docs
  const [archivos, setArchivos] = useState({
    denunciaAdministrativa: [],
    registro: [],
    cedula: [],
    presupuesto: [],
    fotos: [],
    cobertura: [],
    lesiones: [],
    vtv: [],
    formulario08: [],
    denunciaPolicial: [],
    croquis: [],
    propiedad: [],
    fotosAseguradoAGS: [],
    noDestruccion: [],
  });
  const documentosConfig = [
    { key: 'denunciaAdministrativa', title: 'Denuncia administrativa', maxFiles: 2 },
    { key: 'registro', title: 'Registro del conductor', maxFiles: 2 },
    { key: 'cedula', title: 'Cédula', maxFiles: 2 },
    { key: 'presupuesto', title: 'Presupuesto', maxFiles: 2 },
    { key: 'fotos', title: 'Fotos del siniestro', maxFiles: 6 },
    { key: 'cobertura', title: 'Cobertura', maxFiles: 2 },
    { key: 'lesiones', title: 'Lesiones', maxFiles: 2 },
  ];
  const documentosConfig2 = [
    { key: 'vtv', title: 'VTV', maxFiles: 2 },
    { key: 'formulario08', title: 'Formulario 08', maxFiles: 2 },
    { key: 'denunciaPolicial', title: 'Denuncia policial', maxFiles: 2 },
    { key: 'croquis', title: 'Croquis', maxFiles: 2 },
    { key: 'propiedad', title: 'Daños Propiedad', maxFiles: 10 },
    { key: 'fotosAseguradoAGS', title: 'Fotos del asegurado', maxFiles: 6 },
    { key: 'noDestruccion', title: 'Carta de no destrucción total', maxFiles: 2 },
  ];
  const documentosMap = {
    1: 'denunciaAdministrativa',
    2: 'registro',
    3: 'cedula',
    4: 'presupuesto',
    5: 'fotos',
    6: 'cobertura',
    7: 'vtv',
    8: 'formulario08',
    9: 'denunciaPolicial',
    10: 'lesiones',
    11: 'croquis',
    12: 'danioPropiedad',
    13: 'fotosAseguradoAGS',
    14: 'noDestruccion',
  };
  //
  const [isSubmitting, setIsSubmitting] = useState(false);
  const nuevaSolicitud = useCallback(
    async e => {
      e.preventDefault();
      if (isSubmitting) return;
      setIsSubmitting(true);
      const solicitudConId = {
        ...solicitud,
        id3ro: 559,
      };
      Swal.fire({
        title: 'Enviando solicitud...',
        text: 'Por favor espera.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        const response = await axios.post('https://reclamosback.agsseguros.online/apiReclamos/reclamos/nuevaSolicitud', solicitudConId, { withCredentials: true });
        Swal.close();
        if (response.data.success === false) {
          if (response.data.type === 'noStro') {
            Swal.fire({
              icon: 'error',
              width: '50%',
              title: 'No se ha encontrado ninguna denuncia que coincida con los datos ingresados.',
              html: `Si los datos fueron cargados de forma incorrecta, por favor intente nuevamente.<br>
                            Es posible que la denuncia de nuestro asegurado aún no haya sido registrada o se encuentre en proceso de carga.<br>
                            Le sugerimos consultar nuevamente más adelante.`,
            });
            return;
          }
          if (response.data.type === 'reclamoExistente') {
            Swal.fire({
              icon: 'warning',
              width: '50%',
              title: 'Ya existe un reclamo en curso asociado a los datos ingresados.',
              html: `En caso de que se trate de un error, le solicitamos comunicarse telefónicamente con nuestro centro de atención.`,
            });
            return;
          }
        }
        Swal.fire({
          icon: 'success',
          title: 'Reclamo fue cargado con éxito!',
          confirmButtonText: 'Aceptar',
        }).then(async () => {
          const reclamoId = response.data.reclamoId;
          Swal.fire({
            title: 'Actualizando...',
            text: 'Por favor, espera mientras se actualizan los datos y documentos.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          const textoObs = solicitud?.tipoReclamante === 'PEATON' || solicitud?.tipoReclamante === 'PROPIEDAD' ? solicitud?.nombreReclamante : solicitud?.patenteRec;
          //
          const today = new Date();
          let day = today.getDate();
          let month = today.getMonth() + 1;
          const year = today.getFullYear();
          day = day < 10 ? '0' + day : day;
          month = month < 10 ? '0' + month : month;
          const formattedDate = day + '/' + month + '/' + year;
          function getCurrentTime() {
            const now = new Date();
            let hour = now.getHours();
            let minute = now.getMinutes();
            minute = minute < 10 ? '0' + minute : minute;
            return hour + ':' + minute;
          }
          const currentTime = getCurrentTime();
          //
          try {
            const erroresArchivos = [];
            // Actualizar Datos Personales
            const actualizarDatosPersonales = axios.post(
              'https://reclamosback.agsseguros.online/apiReclamos/reclamos/reclamoSinCargar/datosPersonales',
              {
                nombreReclamante: datosPersonales.nombreReclamante,
                dniReclamante: datosPersonales.dniReclamante,
                telefonoReclamante: datosPersonales.telefonoReclamante,
                nombreConductor: mismosDatos ? datosPersonales.nombreReclamante : datosPersonales.nombreConductor,
                dniConductor: mismosDatos ? datosPersonales.dniReclamante : datosPersonales.dniConductor,
                telefonoConductor: mismosDatos ? datosPersonales.telefonoReclamante : datosPersonales.telefonoConductor,
                id: reclamoId,
              },
              { withCredentials: true }
            );
            // Actualizar Relato del Siniestro
            const actualizarRelatoSiniestro = axios.post(
              'https://reclamosback.agsseguros.online/apiReclamos/reclamos/reclamoSinCargar/relatoSiniestro',
              {
                relatoSiniestro: detallesSiniestro.relatoSiniestro,
                id: reclamoId,
              },
              { withCredentials: true }
            );
            // Actualizar Completo
            const actualizarCompleto = axios.post(
              'https://reclamosback.agsseguros.online/apiReclamos/reclamos/completo',
              {
                fueCargado: 1,
                id: reclamoId,
              },
              { withCredentials: true }
            );
            // Actualizar Cronologia
            const actualizarCronologia = axios.post('https://reclamosback.agsseguros.online/apiReclamos/cronologia/cronologiaDesdeTercero', {
              id: reclamoId,
              desc: `El usuario ha cargado el reclamo ${textoObs}`,
              obs: '',
              jerarquia: 'DEN',
              motivo: 'STRO',
              autor: 'Tercero',
              fecha: formattedDate,
              hora: currentTime,
            });
            // Subir Documentos
            const uploadPromises = Object.entries(archivos).map(async ([tipo, files]) => {
              // si no hay archivos de este tipo, no sube nada
              if (!files || files.length === 0) return;
              try {
                const formData = new FormData();
                files.forEach(file => {
                  formData.append('files', file);
                });
                await axios.post(`https://reclamosback.agsseguros.online/apiReclamos/documentacion/doc/${reclamoId}/${tipo}`, formData, {
                  headers: { 'Content-Type': 'multipart/form-data' },
                });
              } catch (error) {
                erroresArchivos.push(error.response?.data?.message || `Error al subir archivos del tipo ${tipo}`);
              }
            });
            // 📌 4️⃣ Ejecutar todo en paralelo
            await Promise.all([actualizarDatosPersonales, actualizarRelatoSiniestro, actualizarCompleto, actualizarCronologia, ...uploadPromises]);
            if (erroresArchivos.length > 0) {
              Swal.fire({
                icon: 'error',
                title: 'Algunos archivos no se pudieron subir',
                html: erroresArchivos.join('<br/>'),
                confirmButtonText: 'Aceptar',
              });
              return;
            }
            Swal.fire({
              icon: 'success',
              title: 'Reclamo Cargado',
              text: 'Aguarde mientras analizamos la información y documentación enviada.',
              confirmButtonText: 'Aceptar',
            }).then(() => {
              window.location.reload();
            });
          } catch (error) {
            console.error('❌ Error en la actualización', error);
            Swal.fire({
              icon: 'error',
              title: 'Error en la actualización',
              text: 'Hubo un problema al actualizar algunos datos. Inténtalo de nuevo.',
              confirmButtonText: 'Aceptar',
            });
          }
        });
      } catch (error) {
        Swal.close();
        setIsSubmitting(false);
        console.error('Error al crear la solicitud:', error);
        if (error.response && error.response.data?.error) {
          Swal.fire({
            icon: 'warning',
            title: 'No se pudo crear la solicitud',
            text: error.response.data.error,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error al crear la solicitud',
            text: 'Hubo un error inesperado. Intenta nuevamente.',
          });
        }
      }
    },
    [solicitud, isSubmitting, datosPersonales, mismosDatos, detallesSiniestro, archivos, documentosMap]
  );
  return (
    <form className='pe-5 ps-5 pb-5' onSubmit={nuevaSolicitud}>
      <h2 className='center pt-5'>Cargar Reclamo</h2>
      <section className='d-flex gap-5 mt-5'>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
          <h4>Datos del Reclamante</h4>
          <div className='d-flex gap-3'>
            <div className='w-100'>
              <label className='d-block'>Fecha de Siniestro (*)</label>
              <input
                id='fechaStroRec'
                type='date'
                required
                value={solicitud.fechaStroRec}
                onChange={e => setSolicitud({ ...solicitud, fechaStroRec: e.target.value })}
                max={new Date().toISOString().split('T')[0]}
                className='form-control form-control-sm'
              />
            </div>
            <div className='w-100'>
              <label className='d-block'>Tipo Vehiculo (*)</label>
              <select
                id='tipoReclamante'
                className='form-select form-select-sm'
                required
                value={solicitud.tipoReclamante}
                onChange={e => {
                  const tipo = e.target.value;
                  setSolicitud(prev => ({
                    ...prev,
                    tipoReclamante: tipo,
                    patenteRec: tipo === 'peaton' || tipo === 'propiedad' ? '' : prev.patenteRec,
                  }));
                }}>
                <option value=''></option>
                <option value='vehiculo'>VEHICULO</option>
                <option value='moto'>MOTO</option>
                <option value='peaton'>PEATON</option>
                <option value='propiedad'>PROPIEDAD</option>
              </select>
            </div>
          </div>
          <div className='d-flex gap-3'>
            <div className='w-100'>
              <label className='d-block'>Patente del Reclamante (*)</label>
              <input
                type='text'
                id='patenteRec'
                className='form-control form-control-sm'
                disabled={solicitud.tipoReclamante === 'peaton' || solicitud.tipoReclamante === 'propiedad'}
                required={solicitud.tipoReclamante !== 'peaton' && solicitud.tipoReclamante !== 'propiedad'}
                value={solicitud.patenteRec}
                onChange={e => setSolicitud({ ...solicitud, patenteRec: e.target.value })}
              />
            </div>
            <div className='w-100'>
              <label className='d-block'>Nombre Reclamante (*)</label>
              <input
                type='text'
                id='nombreReclamante'
                className='form-control form-control-sm'
                required
                value={solicitud.nombreReclamante}
                onChange={e => setSolicitud({ ...solicitud, nombreReclamante: e.target.value })}
              />
            </div>
          </div>
          <h4>Datos del Reclamado (Asegurado en Agrosalta)</h4>
          <div className='d-flex gap-3'>
            <div className='w-100'>
              <label className='d-block'>Patente del Reclamado *</label>
              <input
                type='text'
                id='patenteAseg'
                className='form-control form-control-sm'
                required
                value={solicitud.patenteAseg}
                onChange={e => setSolicitud({ ...solicitud, patenteAseg: e.target.value })}
              />
            </div>
            <div className='w-100'>
              <label className='d-block'>Nombre del Reclamado</label>
              <input
                type='text'
                id='nombreAsegAGS'
                className='form-control form-control-sm'
                value={solicitud.nombreAsegAGS}
                onChange={e => setSolicitud({ ...solicitud, nombreAsegAGS: e.target.value })}
              />
            </div>
          </div>
          <div className='w-100'>
            <textarea
              className='form-control form-control-sm'
              placeholder='Observación adicionales para ubicar el siniestro.'
              style={{ paddingTop: '24px', height: '144px', resize: 'none' }}
              value={solicitud.obsReclamante}
              onChange={e => setSolicitud({ ...solicitud, obsReclamante: e.target.value })}></textarea>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
          <h4>Datos Personales</h4>
          <div className='d-flex gap-3'>
            <div className='w-100'>
              <label className='d-block'>Nombre de reclamante (*)</label>
              <input
                type='text'
                name=''
                id=''
                className='form-control form-control-sm'
                value={datosPersonales.nombreReclamante}
                required
                onChange={e =>
                  setDatosPersonales(prev => ({
                    ...prev,
                    nombreReclamante: e.target.value,
                    ...(mismosDatos && { nombreConductor: e.target.value }),
                  }))
                }
              />
            </div>
            <div className='w-100'>
              <label className='d-block'>DNI (*)</label>
              <input
                type='text'
                name=''
                id=''
                className='form-control form-control-sm'
                value={datosPersonales.dniReclamante}
                required
                onChange={e => {
                  const valor = e.target.value;
                  setDatosPersonales(prev => ({
                    ...prev,
                    dniReclamante: valor,
                    ...(mismosDatos && { dniConductor: valor }),
                  }));
                  validarCampo('dniReclamante', valor);
                }}
              />
              {errores.dniReclamante && <p className='text-danger'>{errores.dniReclamante}</p>}
            </div>
            <div className='w-100'>
              <label className='d-block'>Telefono (*)</label>
              <input
                type='text'
                name=''
                id=''
                className='form-control form-control-sm'
                value={datosPersonales.telefonoReclamante}
                required
                onChange={e => {
                  const valor = e.target.value;
                  setDatosPersonales(prev => ({
                    ...prev,
                    telefonoReclamante: valor,
                    ...(mismosDatos && { telefonoConductor: valor }),
                  }));
                  validarCampo('telefonoReclamante', valor);
                }}
              />
              {errores.telefonoReclamante && <p className='text-danger'>{errores.telefonoReclamante}</p>}
            </div>
          </div>
          {!mismosDatos ? (
            <div className='d-flex gap-3'>
              <div className='w-100'>
                <label className='d-block'>Nombre de conductor (*)</label>
                <input
                  type='text'
                  name=''
                  id=''
                  className='form-control form-control-sm'
                  value={datosPersonales.nombreConductor}
                  required
                  onChange={e =>
                    setDatosPersonales(prev => ({
                      ...prev,
                      nombreConductor: e.target.value,
                    }))
                  }
                />
              </div>
              <div className='w-100'>
                <label className='d-block'>DNI (*)</label>
                <input
                  type='text'
                  name=''
                  id=''
                  className='form-control form-control-sm'
                  value={datosPersonales.dniConductor}
                  required
                  onChange={e =>
                    setDatosPersonales(prev => ({
                      ...prev,
                      dniConductor: e.target.value,
                    }))
                  }
                />
              </div>
              <div className='w-100'>
                <label className='d-block'>Telefono (*)</label>
                <input
                  type='text'
                  name=''
                  id=''
                  className='form-control form-control-sm'
                  value={datosPersonales.telefonoConductor}
                  required
                  onChange={e =>
                    setDatosPersonales(prev => ({
                      ...prev,
                      telefonoConductor: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
          ) : null}
          <div className='form-check'>
            <input className='form-check-input' type='checkbox' id='mismosDatos' checked={mismosDatos === 1} onChange={e => setMismosDatos(e.target.checked ? 1 : 0)} />
            <label className='form-check-label' htmlFor='mismosDatos'>
              Mismos datos que conductor
            </label>
          </div>
          <h4>Detalles del siniestro</h4>
          <div className='w-100'>
            <label className='d-block'>Relato del Siniestro</label>
            <textarea
              className='form-control form-control-sm'
              style={{ paddingTop: '24px', height: '144px', resize: 'none' }}
              value={detallesSiniestro.relatoSiniestro}
              onChange={e => setDetallesSiniestro(prevDatos => ({ ...prevDatos, relatoSiniestro: e.target.value }))}
            />
          </div>
        </div>
      </section>
      <h3 className='mt-5'>Documentos Obligatorios</h3>
      <div className='grid-docs'>
        {documentosConfig.map(doc => (
          <CardDocsCargarReclamo key={doc.key} docKey={doc.key} title={doc.title} maxFiles={doc.maxFiles} archivos={archivos} setArchivos={setArchivos} />
        ))}
      </div>
      <hr />
      <h3 className=''>Documentos Opcionales</h3>
      <div className='grid-docs'>
        {documentosConfig2.map(doc => (
          <CardDocsCargarReclamo key={doc.key} docKey={doc.key} title={doc.title} maxFiles={doc.maxFiles} archivos={archivos} setArchivos={setArchivos} />
        ))}
      </div>
      <div className='center mt-5'>
        <button className='btn btn-sm btn-primary' type='submit'>
          Crear Reclamo
        </button>
      </div>
    </form>
  );
}
